import type { SVGProps } from 'react';

const SvgInfinity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="9"
    viewBox="0 0 19 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.7104 1.25891C13.3686 -0.23943 15.8998 -0.23921 17.5581 1.25891L17.7212 1.41321C19.4257 3.11785 19.4257 5.88245 17.7212 7.58704L17.5581 7.74133C15.8447 9.28928 13.1987 9.2382 11.5474 7.58704L9.72119 5.76086L7.89697 7.58704L7.73389 7.74133C6.07557 9.23965 3.54454 9.23965 1.88623 7.74133L1.72314 7.58704C0.0184391 5.88232 0.0184794 3.11794 1.72314 1.41321L1.88623 1.25891C3.59984 -0.289394 6.24543 -0.238205 7.89697 1.41321L9.72119 3.2384L11.5474 1.41321L11.7104 1.25891ZM6.62354 2.68665C5.6217 1.68495 3.99745 1.6848 2.99561 2.68665C1.99416 3.6885 1.99398 5.31294 2.99561 6.31458C3.99729 7.31622 5.62173 7.31603 6.62354 6.31458L8.43799 4.50012L6.62354 2.68665ZM16.4478 2.68567C15.446 1.68449 13.8223 1.68515 12.8208 2.68665L11.0073 4.50012L12.8208 6.3136C13.8225 7.31509 15.4461 7.31508 16.4478 6.3136C17.4494 5.3119 17.4494 3.68735 16.4478 2.68567Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgInfinity;
